exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inactive {\n\tfont-size: 16px;\n}\n\n.inactive .badge {\n\tmargin-top: -3px;\n}\n", ""]);

// exports
